<template>
  <div class="video-chat">
    <div class="h-dvh" style="width: 100%; height: 100%; position: absolute; background: #151515; left: 0; top: 0;">
      <div class="relative" style="width: 100%; height: 100%;">
        <div v-if="popupMessage" class="popup-message" style="position: absolute; left: 0; top: 0; z-index: 9999; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
          <div style="background: #fff; color: #000; border-radius: 8px; padding: 16px; max-width: 60%;">
            <h5>{{popupMessage.title}}</h5>
            <p>{{popupMessage.message}}</p>

            <div class="d-flex justify-content-end">
              <a href="#" @click.prevent="popupMessage = null;" style="font-size: 16px;">OK</a>
            </div>
          </div>
        </div>

        <div style="height: 85%; position: relative;">
          <div style="
                position: absolute; width: 100%; height: 100%; display: flex; justify-content: center; align-items: flex-start;
                z-index: 50; margin: 0; color: #656565; font-size: 24px; gap: 24px; padding: 12px;">
            <div>
              <span v-if="conversationUser" style="display: block;">{{ conversationUser }}</span>
              <span v-if="!conversationUserInCall" style="display: block; font-size: 14px;">No one in call</span>
              <span v-else style="display: block; font-size: 14px;">On going call</span>

              <span style="display: block; font-size: 14px;" v-if="isLoading && !error">Loading..</span>
              <span style="display: block; font-size: 14px;" v-if="error" v-html="error"></span>
            </div>
          </div>

          <div v-if="!peerVideoStream" style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 5; background: #000;"></div>

          <VideoPreview id="remote" :stream="peerVideoStream" :hasVideo="peerVideoStreamHasVideo" :hasAudio="peerVideoStreamHasAudio"
                        style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 3;"
          />

          <div style="
                position: absolute; display: flex; justify-content: center; align-items: flex-end;
                z-index: 50; margin: 0; color: #656565; font-size: 24px; gap: 24px; padding: 12px; bottom: 0;">
            <i v-show="!peerVideoStreamHasAudio" :class="'feather-mic-off'"></i>
            <i v-if="!peerVideoStreamHasVideo" :class="'feather-video-off'"></i>
          </div>

          <div class="local-video-block" style="
              width: 100px;
              height: 100px;
              position: absolute; bottom: 10px; right: 10px; z-index: 50;
          ">
            <div style="position: relative; width: 100%; height: 100%;">
              <div
                v-if="!videoStream"
                style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 5; background: #000; border-radius: 6px; border: 2px solid #b6981c;"></div>

              <div v-if="!videoStreamHasVideo" style="
                position: absolute; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;
                z-index: 50; margin: 0; color: #d17373; font-size: 16px;">
                <i :class="'feather-video-off'"></i>
              </div>

              <video
                id="localVideo"
                ref="video"
                autoplay
                playsinline
                class="w-full h-full object-cover"
                :muted="true"
                style="width: 100%; height: 100%; z-index: 3;"
              ></video>
            </div>
          </div>
        </div>

        <VideoControl
          :videoAvailable="devicesAvailability.camera"
          :audioAvailable="devicesAvailability.microphone"
          :isVideoOn="videoStreamHasVideo"
                      :isMicOn="videoStreamHasAudio"
                      :toggleVideo="handleVideoToggle"
                      :toggleMute="handleMuteToggle"
                      :endCall="handleEndCall"
                      style="height: 15%;"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import io from "socket.io-client";
import config from "@/config";
import VideoChatInfo from "@/components/frontend/videochat/VideoChatInfo.vue";
import VideoPreview from "@/components/frontend/videochat/VideoPreview.vue";
import VideoControl from "@/components/frontend/videochat/VideoControl.vue";

export default {
  components: {VideoControl, VideoPreview, VideoChatInfo},
  data() {
    return {
      logs: [],
      popupMessage: null,
      devicesAvailability: {
        camera: false,
        microphone: false,
      },
      peerVideoStream: null,
      peerVideoStreamHasVideo: false,
      peerVideoStreamHasAudio: false,
      videoStream: null,
      isLoading: false,
      error: null,
      socket: null,
      peerConnection: null,
      videoStreamHasVideo: false,
      videoStreamHasAudio: false,
      callingInfo: 'Video Chat',
      callingUserId: false,
      callStarted: false,

      conversation: null,
      currentUserId: null,
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      conversations: 'chat/conversations',
      currentChatUser: 'chat/currentChatUser',
    }),

    conversationUser() {
      return this.conversation ? this.conversation.user.username : '';
    },

    conversationUserInCall() {
      return !!this.peerVideoStream;
    },

    users() {
      return this.conversations.map(e => {
        return {
          ...e.user,
          conversation_id: e.id,
        };
      });
    },
  },

  mounted() {
    this.l('Mounted');

    this.searchForAudioAndVideo(() => {
      this.currentUserId = Math.floor(Math.random() * 100);
      this.l(`User id: ${this.currentUserId}`);

      // this.$eventHub.$on('StartVideoCall', this.StartVideoCall);
      // this.$eventHub.$on('EndVideoCall', this.handleEndCall);
      // this.$eventHub.$on('VideoCallDeclined', this.VideoCallDeclined);

      this.reset();
      this.bootstrap();
    });
  },

  unmounted() {
    this.$eventHub.$off('StartVideoCall', this.StartVideoCall);
    this.$eventHub.$off('EndVideoCall', this.handleEndCall);
    this.$eventHub.$off('VideoCallDeclined', this.VideoCallDeclined);
  },

  methods: {
    l(message) {
      this.logs.push(message);
    },

    closePopup() {
      this.popupMessage = null;
    },

    showPopup(title, message) {
      this.popupMessage = {title, message};
    },

    searchForAudioAndVideo(cb) {
      navigator.mediaDevices.enumerateDevices()
        .then(devices => {
          devices.map(e => { return {b: e.kind, a: e.label} })

          this.devicesAvailability = {
            camera: !!devices.find(e => e.kind === 'videoinput'),
            microphone: !!devices.find(e => e.kind === 'audioinput'),
          };

          cb();
        });
    },

    async bootstrap() {
      this.l(`Bootstrap`);
      this.isLoading = true;
      this.conversation = await this.$store.dispatch('chat/getProcessedConversation', this.$route.params.conversationId);
      this.l(`Conversation: ${this.conversation?.id}`);

      try {
        await this.init(this.conversation.id, this.createRoom);
        this.isLoading = false;
      } catch (e) {
        await this.init(this.conversation.id, this.verifyRoom);
        this.isLoading = false;
      }
    },

    reset() {
      this.videoCall = null;
      this.callingInfo = 'Video Chat';
      this.peerVideoStream = null;
      this.peerVideoStreamHasVideo = false;
      this.peerVideoStreamHasAudio = false;
      this.videoStream = null;
      this.isLoading = false;
      this.error = null;
      this.socket = null;
      this.peerConnection = null;
      this.videoStreamHasVideo = false;
      this.videoStreamHasAudio = false;
      this.callingInfo = 'Video Chat';
      this.callingUserId = false;
      this.callStarted = false;
    },

    StartVideoCall({current_user, room_id, user_id, current_user_id}) {
      return;
      this.videoCall = {
        current_user, room_id, user_id, current_user_id
      };

      if (current_user) {
        this.init(room_id, this.createRoom);
      } else {
        this.init(room_id, this.verifyRoom);
      }
    },

    VideoCallDeclined() {
      this.reset();
    },

    async AskForCall(userId, conversationId) {
      this.callingUserId = userId;
      this.callStarted = false;

      await this.$store.dispatch('chat/sendMessage', {
        user_id: this.currentUserId,
        to_user_id: userId,
        conversationId: conversationId,
        type: 'call',
        content: 'call',
      });

      setTimeout(() => {
        this.callingUserId = false;
      }, 15 * 1000);
    },

    AcceptCall(userId) {
      this.instance.acceptCall(userId);
      this.callingInfo = '';
    },

    DeclineCall(userId) {
      this.callingInfo = 'Audio/Video Chat';
      this.instance.declineCall(userId);
    },

    EndCall() {
      this.callingInfo = 'Audio/Video Chat';
      this.instance.endCall();
    },

    async init(room_id, fn) {
      this.reset();
      this.setError('');

      this.l(`Init peer connection`);

      this.peerConnection = new RTCPeerConnection({
        iceServers: [
          {
            urls: 'stun:159.223.246.216:5349',
            username: 'admin',
            credential: 'dappturn555',
          },
          {
            urls: 'turn:159.223.246.216:5349',
            username: 'admin',
            credential: 'dappturn555',
          },
          // {urls: "stun:stun.l.google.com:19302"}, {urls: "stun:stun.l.google.com:5349"}, {urls: "stun:stun1.l.google.com:3478"}, {urls: "stun:stun1.l.google.com:5349"}, {urls: "stun:stun2.l.google.com:19302"}, {urls: "stun:stun2.l.google.com:5349"}, {urls: "stun:stun3.l.google.com:3478"}, {urls: "stun:stun3.l.google.com:5349"}, {urls: "stun:stun4.l.google.com:19302"}, {urls: "stun:stun4.l.google.com:5349"}
        ],
      });

      if (this.socket) {
        this.socket.disconnect();
        this.socket = null;
      }

      this.l(`Init room_id: ${room_id}`);

      await fn(room_id)
        .then(r => {
          return navigator.mediaDevices.getUserMedia({
            video: true, audio: true
          })
            .then((stream) => {
              this.l(`Got Stream`);
              this.setVideoStream(stream);
              console.log('stream', this.videoStream)

              stream.getVideoTracks().forEach(e => {
                e.enabled = this.videoStreamHasVideo;
              })
              stream.getAudioTracks().forEach(e => {
                e.enabled = this.videoStreamHasAudio;
              })

              this.setVideoStreamHasVideo(stream.getVideoTracks().some((track) => track.enabled));
              this.setVideoStreamHasAudio(stream.getAudioTracks().some((track) => track.enabled));

              stream.getTracks().forEach((track) => {
                this.peerConnection.addTrack(track, stream);
              });

              this.socket = io.connect(config.SOCKET_API_URL, {port: 5000});
              this.l(`Socket OK`);
              console.log('socket', this.socket, config.SOCKET_API_URL)

              this.bindEvents();

              console.log('join', this.currentUserId)
              this.l(`Joining`);
              this.socket.emit("join-room", {roomCode: room_id, password: room_id, userId: this.currentUserId});
              this.l(`Joined`);

              this.socket.emit("stateChange", {
                hasVideo: this.videoStreamHasVideo,
                hasAudio: this.videoStreamHasAudio,
              });
            })
          .catch(err => {
            this.l(`Error: UserMedia 1: ${err.name}`);
            this.l(`Error: UserMedia 2: ${JSON.stringify(err)}`);
            this.l(`Error: UserMedia 3: ${err}`);

            navigator.permissions.query({name: 'camera'})
              .then((permissionObj) => {
                console.log(permissionObj.state);
                this.init(room_id, fn);
              })
              .catch((err) => {
                console.log('Got error :', err);
                this.l(`Error: Permissions 1: ${err.name}`);
                this.l(`Error: Permissions 2: ${JSON.stringify(err)}`);
                this.l(`Error: Permissions 3: ${err}`);

                if (err.name === "NotAllowedError" || err.name === "PermissionDeniedError") {
                  this.setError("Please allow camera and microphone access to join the meeting by clicking on the lock icon in the address bar.");
                } else {
                  console.error(`VideoChat error: ${err}`);
                  this.setError(`Audio/Video not found. Please <a href="" style="text-decoration: underline; color: #9092fd;">try again</a>.`);
                  this.devicesAvailability.camera = false;
                }
              })
          })
        })
        .catch((err) => {
          this.setError('');
          this.l(`Error: fn 1: ${err.name}`);
          this.l(`Error: fn 2: ${JSON.stringify(err)}`);
          this.l(`Error: fn 3: ${err}`);

          if (err.name === "NotAllowedError" || err.name === "PermissionDeniedError") {
            this.setError("Please allow camera and microphone access to join the meeting by clicking on the lock icon in the address bar.");
          } else {
            console.error(`VideoChat error: ${err}`);
            this.setError(`Audio/Video not found. Please <a href="" style="text-decoration: underline; color: #9092fd;">try again</a>.`);
            this.devicesAvailability.camera = false;
          }
        })
        .finally(() => {
          this.setIsLoading(false);
          navigator.mediaDevices.enumerateDevices().then(devices => {
            this.l(`Devices :: ${JSON.stringify(devices.map(e => { return {b: e.kind, a: e.label} }))}`);
          });
        });
    },

    async createRoom(room_id) {
      try {
        await this.$store.dispatch('videochat/createRoom', {
          roomCode: room_id,
          password: room_id,
        });
      } catch (err) {
        this.l(`Error: createRoom 1: ${err.name}`);
        this.l(`Error: createRoom 2: ${JSON.stringify(err)}`);
        this.l(`Error: createRoom 3: ${err}`);
        this.l(`Error: createRoom 4: ${err.response?.data}`);

        try {
          await this.joinRoom(room_id);
        } catch (err) {
          this.l(`Error: joinRoom 1: ${err.name}`);
          this.l(`Error: joinRoom 2: ${JSON.stringify(err)}`);
          this.l(`Error: joinRoom 3: ${err}`);
          this.l(`Error: joinRoom 4: ${err.response?.data}`);
        }
      }
    },

    async joinRoom(room_id) {
      const r = await this.$store.dispatch('videochat/joinRoom', {
        roomCode: room_id,
        password: room_id,
      });
    },

    async verifyRoom(room_id) {
      const r = await this.$store.dispatch('videochat/joinRoom', {
        roomCode: room_id,
        password: room_id,
      });
      this.l(`123`);

      console.log('verifyRoom', r)
    },

    setVideoStream(value) {
      this.videoStream = value;
      document.querySelector('#localVideo').srcObject = value;
      document.querySelector('#localVideo').autoplay = true;
      document.querySelector('#localVideo').muted = true;
    },

    setVideoStreamHasVideo(value) {
      this.videoStreamHasVideo = value;
    },

    setVideoStreamHasAudio(value) {
      this.videoStreamHasAudio = value;
    },

    setPeerVideoStream(value) {
      this.l(`Got peer video stream`);
      this.l(`Stream: ${JSON.stringify(value)}`);
      console.log('setPeerVideoStream', value)
      this.peerVideoStream = value;
    },

    setPeerVideoStreamHasVideo(value) {
      this.peerVideoStreamHasVideo = value;
    },

    setPeerVideoStreamHasAudio(value) {
      this.peerVideoStreamHasAudio = value;
    },

    handleEndCall() {
      if (this.videoCall) {
        this.$store.dispatch('chat/sendMessage', {
          user_id: this.videoCall.current_user_id,
          to_user_id: this.videoCall.user_id,
          conversationId: this.videoCall.room_id,
          type: 'call',
          content: 'end',
        });
      }

      const stopTrack = track => {
        track.enabled = false;
        track.stop();
      };

      if (this.peerVideoStream) {
        this.peerVideoStream.getTracks().forEach(stopTrack);
        this.peerVideoStream.getVideoTracks().forEach(stopTrack);
        this.peerVideoStream.getAudioTracks().forEach(stopTrack);
        this.peerVideoStream = null;
      }

      if (this.videoStream) {
        this.videoStream.getTracks().forEach(stopTrack);
        this.videoStream.getVideoTracks().forEach(stopTrack);
        this.videoStream.getAudioTracks().forEach(stopTrack);
        this.videoStream = null;
      }

      document.querySelector('#localVideo').srcObject = null;
      document.querySelector('#remote').srcObject = null;

      this.unbindEvents();
      this.reset();
      this.$router.back();
    },

    handleMuteToggle() {
      console.log('handleMuteToggle')
      if (!this.devicesAvailability.microphone) {
        this.showPopup(
          'Can\'t find your microphone',
          'Check your system settings and see if you can find your microphone. You may need to restart your browser.',
        );
        return;
      }

      if (!this.peerConnection) {
        return;
      }

      this.peerConnection.getSenders().forEach((sender) => {
        if (sender?.track?.kind === "audio") {
          sender.track.enabled = !this.videoStreamHasAudio;
        }
      });

      this.socket.emit("stateChange", {
        hasVideo: this.videoStreamHasVideo,
        hasAudio: !this.videoStreamHasAudio,
      });

      this.setVideoStreamHasAudio(!this.videoStreamHasAudio);
    },

    handleVideoToggle() {
      console.log('handleVideoToggle')
      if (!this.devicesAvailability.camera) {
        this.showPopup(
          'Can\'t find your camera',
          'Check your system settings and see if you can find your camera. You may need to restart your browser.',
        );
        return;
      }

      if (!this.peerConnection) {
        return;
      }

      this.peerConnection.getSenders().forEach((sender) => {
        if (sender?.track?.kind === "video") {
          sender.track.enabled = !this.videoStreamHasVideo;
        }
      });

      this.socket.emit("stateChange", {
        hasVideo: !this.videoStreamHasVideo,
        hasAudio: this.videoStreamHasAudio,
      });

      this.setVideoStreamHasVideo(!this.videoStreamHasVideo);
    },

    unbindEvents() {
      this.l(`---> Unbind events`);
      if (!this.socket) {
        return;
      }

      this.socket.off("user-connected");
      this.socket.off("user-disconnected");
      this.socket.off("offer");
      this.socket.off("answer");
      this.socket.off("candidate");
      this.socket.off("stateChange");

      this.peerConnection.onicecandidate = null;
      this.peerConnection.ontrack = null;
      this.peerConnection.onconnectionstatechange = null;
    },

    bindEvents() {
      this.l(`---> Bind events`);
      console.log('bind', this.socket, this.peerConnection)

      this.socket.on("user-connected", () => {
        this.l(`---> User connected`);

        console.log('user-connected')
        this.peerConnection.createOffer().then((offer) => {
          this.l(`---> Created offer`);
          this.peerConnection.setLocalDescription(offer);
          this.socket.emit("offer", offer);
        });
      });

      this.socket.on("user-disconnected", () => {
        this.l(`---> User disconnected`);
        console.log('user-disconnected')
        this.setPeerVideoStream(null);
        // this.handleEndCall();
      });

      this.socket.on("offer", (offer) => {
        this.l(`---> Got offer`);
        console.log('offer')
        this.peerConnection
          .setRemoteDescription(new RTCSessionDescription(offer))
          .then(() => this.peerConnection.createAnswer())
          .then((answer) => {
            this.peerConnection.setLocalDescription(answer);
            this.socket.emit("answer", answer);
          })
          .catch(e => {
            console.error('Remote descriptor error', e)
          })
      });

      this.socket.on("answer", (answer) => {
        console.log('answer')
        this.l(`---> Got answer`);
        this.peerConnection.setRemoteDescription(new RTCSessionDescription(answer));
      });

      this.socket.on("candidate", (candidate) => {
        console.log('candidate')
        this.l(`---> New candidate`);
        this.peerConnection?.addIceCandidate(new RTCIceCandidate(candidate));
      });

      this.socket.on("stateChange", ({ hasVideo, hasAudio }) => {
        console.log('stateChange')
        this.l(`---> State Changed...`);
        this.l(`VIDEO: ${hasVideo} | AUDIO: ${hasAudio}`);
        this.setPeerVideoStreamHasVideo(hasVideo);
        this.setPeerVideoStreamHasAudio(hasAudio);
      });

      this.peerConnection.onicecandidate = (event) => {
        if (event.candidate) this.socket.emit("candidate", event.candidate);
      };

      this.peerConnection.ontrack = (event) => {
        this.setPeerVideoStream(event.streams[0]);

        this.setPeerVideoStreamHasVideo(event.streams[0].getVideoTracks().length > 0);
        this.setPeerVideoStreamHasAudio(event.streams[0].getAudioTracks().length > 0);
      };

      this.peerConnection.onconnectionstatechange = () => {
        this.l(`---> Conn State Changed: ${this.peerConnection.connectionState}`);
        if (this.peerConnection.connectionState === "disconnected" || this.peerConnection.connectionState === "closed") this.setPeerVideoStream(null);
      };
    },

    setError(value) {
      this.error = value;
    },

    setIsLoading(value) {
      this.isLoading = value;
    },
  },
}
</script>
